<template>
  <div id="whatcovered-iphone" class="modal show">
    <div id="whatcovered-iphone-white" class="white animationup">
      <a class="close" @click="close"></a>
      <div class="content" v-html="compiledHTML"></div>
    </div>
  </div>
</template>

<script>
import axiosCustom from "@/utils/axiosCustom";

export default {
  props: {
    chartName: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      compiledHTML: "",
    };
  },
  mounted() {
    console.log("Mounted", this.chartName);
    axiosCustom({
      method: "get",
      url: `/rest/V1/ccmsBlock/${this.chartName}`,
    })
      .then((result) => {
        console.log(result.data);
        if (result.data && result.data.content) {
          let htmlString = new DOMParser().parseFromString(
            result.data.content,
            "text/html"
          );
          console.log(htmlString);
          this.compiledHTML = htmlString.documentElement.textContent;
        }
      })
      .catch((error) => {
        console.error("error getting file");
      });
  },
  methods: {
    close() {
      console.log("Close");
      console.log(this.$route.params.dest);
      if (this.$route.params.dest) {
        this.$router.push({ name: this.$route.params.dest });
      } else {
        this.$router.push({ name: "home" });
      }
    },
  },
};
</script>
